import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { handleMarvAdviceCookieForQueryOnSuccess } from '@/features/shared/utils/marv'

export const useHandleMarvCampaign = () => {
  const queryClient = useQueryClient()

  useEffect(() => {
    const queryCache = queryClient.getQueryCache()

    // on mount, process any queries that succeeded server side (SSR/dehydration) before
    // this hook subscribes to the query cache. sorted by dataUpdatedAt so cookies are
    // applied oldest first, matching the order in which the data was originally fetched.
    queryCache
      .getAll()
      .filter((query) => query.state.status === 'success')
      .sort((a, b) => a.state.dataUpdatedAt - b.state.dataUpdatedAt)
      .forEach(handleMarvAdviceCookieForQueryOnSuccess)

    const unsubscribe = queryCache.subscribe((event) => {
      // the event type has to be 'updated' in order for the action type to be 'success'
      if (event.type === 'updated' && event.action.type === 'success') {
        handleMarvAdviceCookieForQueryOnSuccess(event.query)
      }
    })
    return () => unsubscribe()
  }, [queryClient])
}
